(function () {
  'use strict';

  const modal = document.getElementById('login-otp-modal');
  if (!modal) return;

  const backendUrl = (modal.dataset.backendUrl || '').replace(/\/+$/, '');
  const verifyPath = modal.dataset.verifyPath || '/login/verify';

  const stepPhone = modal.querySelector('[data-otp-step="phone"]');
  const stepRegister = modal.querySelector('[data-otp-step="register"]');
  const phoneForm = modal.querySelector('[data-otp-form="phone"]');
  const registerForm = modal.querySelector('[data-otp-form="register"]');
  const phoneInput = phoneForm.querySelector('#otp-phone');
  const phoneDisplay = registerForm.querySelector('[data-otp-phone-display]');
  const changePhoneBtn = registerForm.querySelector('[data-otp-change-phone]');

  const ERROR_MESSAGES = {
    invalid_phone: 'מספר טלפון לא תקין',
    invalid_email: 'כתובת דוא״ל לא תקינה',
    missing_name: 'יש למלא שם פרטי ושם משפחה',
    cooldown: 'נא להמתין מספר שניות לפני שליחה נוספת',
    hourly_phone_limit: 'חרגת ממספר הניסיונות לשעה. נסה שוב מאוחר יותר',
    daily_phone_limit: 'חרגת ממספר הניסיונות ליום. נסה שוב מחר',
    hourly_ip_limit: 'יותר מדי בקשות מהכתובת הזו. נסה שוב מאוחר יותר',
    sms_failed: 'שליחת ה-SMS נכשלה. נסה שוב',
    email_taken: 'כתובת האימייל כבר בשימוש. אנא היכנס עם המספר הרשום או השתמש באימייל אחר',
    network: 'תקלה ברשת. נסה שוב',
    config: 'שירות ההתחברות אינו מוגדר. צור קשר עם התמיכה',
    generic: 'משהו השתבש. נסה שוב'
  };

  const panel = modal.querySelector('.otp-modal__panel');
  let currentTrigger = null;

  // Gap kept between the panel's bottom edge and the bottom of the screen.
  const BOTTOM_MARGIN = 36;

  // Visible viewport height. Prefer visualViewport (accounts for mobile
  // browser UI / dynamic toolbars, matching the CSS `svh` unit) and fall back
  // to the document client height so the panel never runs past the screen.
  function viewportHeight() {
    if (window.visualViewport) return window.visualViewport.height;
    return document.documentElement.clientHeight || window.innerHeight;
  }

  function positionPanel() {
    if (!currentTrigger) return;
    const rect = currentTrigger.getBoundingClientRect();
    const top = Math.round(rect.bottom + 20);
    const startEdge = Math.max(8, Math.round(rect.left) - 170);
    panel.style.top = top + 'px';
    panel.style.left = startEdge + 'px';
    panel.style.right = 'auto';
    panel.style.insetInlineStart = 'auto';
    const panelWidth = panel.offsetWidth;
    if (startEdge + panelWidth > window.innerWidth - 8) {
      panel.style.left = Math.max(8, window.innerWidth - panelWidth - 8) + 'px';
    }
    // Dynamic height: screen height minus the panel's distance from the top
    // (which already accounts for the header + announcement bar, since `top`
    // tracks the trigger below them) minus a small bottom gap. This adapts to
    // every screen size and grows automatically when the announcement bar
    // scrolls away and the header sticks.
    const availableHeight = Math.max(0, viewportHeight() - top - BOTTOM_MARGIN);
    modal.style.setProperty('--otp-panel-height', availableHeight + 'px');
  }

  function open(trigger) {
    currentTrigger = trigger || null;
    modal.hidden = false;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    if (currentTrigger) positionPanel();
    setTimeout(() => phoneInput && phoneInput.focus(), 30);
  }

  function close() {
    modal.classList.remove('is-open');
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    currentTrigger = null;
    showStep('phone');
    clearErrors();
  }

  const reposition = () => { if (!modal.hidden) positionPanel(); };
  window.addEventListener('resize', reposition);
  window.addEventListener('scroll', reposition, { passive: true });
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', reposition);
    window.visualViewport.addEventListener('scroll', reposition);
  }

  function showStep(name) {
    stepPhone.hidden = name !== 'phone';
    stepRegister.hidden = name !== 'register';
  }

  function clearErrors() {
    modal.querySelectorAll('[data-otp-error]').forEach(el => {
      el.hidden = true;
      el.textContent = '';
    });
  }

  function showError(scope, code, fallbackMessage) {
    const el = modal.querySelector(`[data-otp-error="${scope}"]`);
    if (!el) return;
    el.textContent = ERROR_MESSAGES[code] || fallbackMessage || ERROR_MESSAGES.generic;
    el.hidden = false;
  }

  function setLoading(form, loading) {
    const btn = form.querySelector('[data-otp-submit]');
    const spinner = btn.querySelector('.otp-modal__spinner');
    btn.disabled = loading;
    spinner.hidden = !loading;
  }

  async function apiPost(path, body) {
    if (!backendUrl) {
      const err = new Error('config');
      err.code = 'config';
      throw err;
    }
    let res;
    try {
      res = await fetch(backendUrl + path, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      });
    } catch (e) {
      const err = new Error('network');
      err.code = 'network';
      throw err;
    }
    let data = {};
    try { data = await res.json(); } catch (e) { /* ignore */ }
    if (!res.ok) {
      const err = new Error(data.error || 'generic');
      err.code = data.error || 'generic';
      err.status = res.status;
      err.serverMessage = data.message || '';
      throw err;
    }
    return data;
  }

  function redirectToVerify(phone) {
    window.location.href = '/customer_authentication/login'
      + '?login_hint=' + encodeURIComponent(phone)
      + '&return_to=' + encodeURIComponent(window.location.pathname + window.location.search);
  }

  let pendingPhone = '';
  let pendingNormalizedPhone = '';

  phoneForm.addEventListener('submit', async (e) => {
    e.preventDefault();
    clearErrors();
    const phone = phoneInput.value.trim();
    if (!phone) {
      showError('phone', 'invalid_phone');
      return;
    }
    setLoading(phoneForm, true);
    try {
      const lookup = await apiPost('/api/storefront/phone-lookup', { phone });
      pendingPhone = phone;
      pendingNormalizedPhone = lookup.normalizedPhone || phone;

      if (lookup.exists) {
        await apiPost('/api/storefront/send-otp', { phone: pendingPhone });
        redirectToVerify(pendingPhone);
      } else {
        phoneDisplay.value = pendingPhone;
        showStep('register');
      }
    } catch (err) {
      showError('phone', err.code, err.serverMessage);
    } finally {
      setLoading(phoneForm, false);
    }
  });

  registerForm.addEventListener('submit', async (e) => {
    e.preventDefault();
    clearErrors();

    const firstName = registerForm.firstName.value.trim();
    const lastName = registerForm.lastName.value.trim();
    const email = registerForm.email.value.trim();
    const petName = registerForm.petName.value.trim();

    if (!firstName || !lastName) { showError('register', 'missing_name'); return; }
    if (!email) { showError('register', 'invalid_email'); return; }

    setLoading(registerForm, true);
    try {
      await apiPost('/api/storefront/send-otp', {
        phone: pendingPhone,
        register: {
          firstName,
          lastName,
          email,
          petName,
          privacyAccepted: true,
          dataConsentAccepted: true
        }
      });
      try { localStorage.setItem('anipet_pending_register', '1'); } catch (e) { /* ignore */ }
      redirectToVerify(pendingPhone);
    } catch (err) {
      showError('register', err.code, err.serverMessage);
    } finally {
      setLoading(registerForm, false);
    }
  });

  changePhoneBtn.addEventListener('click', () => {
    clearErrors();
    showStep('phone');
    setTimeout(() => phoneInput && phoneInput.focus(), 30);
  });

  modal.querySelectorAll('[data-otp-close]').forEach(el => {
    el.addEventListener('click', close);
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !modal.hidden) close();
  });

  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-otp-login-trigger]');
    if (!trigger) return;
    e.preventDefault();
    const anchorSelector = trigger.getAttribute('data-otp-anchor-selector');
    const anchor = anchorSelector ? document.querySelector(anchorSelector) : trigger;
    open(anchor || trigger);
  });
})();
